import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente ModalBox
 */
export const ModalBox = styled.div`
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color: #000;
  border-radius: 2px;
  padding: 40px;
  box-sizing: border-box;
  outline: 0;
  padding-top: 20px;
  padding-bottom: 30px;
  max-width: 400px;
  height: 235px;

  header {
    border-bottom: 1px solid #e6e6e6;
    margin: 10px 0 20px 0;
    h2 {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 300;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: left;
      color: #5E6366;
      margin-bottom: 12px;
    }
  }
  .close {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
  .content {
    padding-left: 10px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: #5E6366
  }
  footer {    
    .dont-show-again {
      p{      
        display:inline:
      }
      .mensage{
        display:inline:
      }
      display:inline:
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #5e6366;
    }
    .button{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    text-transform: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 20px;
    width: 128px;
    height: 32.6px;
    border-radius: 3px;
  }

  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-containedPrimary {
    color: #fff;
    background-color: #3c71dd;
    top: 10px;
  }
`;

/**
 * Estilização do componente StyledCheckbox
 */
export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-colorPrimary.Mui-checked {
    color: #3c71dd;
  }

  .MuiSvgIcon-fontSizeSmall {
    font-size: 1rem;
  }
`;
